<template>
    <div class="course">
        <div class="information">
            <div class="columns">
                <div class="column is-narrow is-hidden-touch">
                    <i class="fad fa-browsers has-text-primary fa-2x"></i>
                </div>
                <div class="column">
                    <div class="columns is-block-tablet is-flex-widescreen">
                        <div class="column">
                            <div class="has-text-weight-bold">
                                <i class="fad fa-browsers has-text-primary is-hidden-desktop mr-2"></i>
                                {{ course.title }}
                            </div>
                            <div class="meta">
                                {{ course.organization.title }}
                            </div>
                            <router-link to="/enrollments" v-if="course.enrolled">
                                <b-message type="is-success" class="mt-4"><i class="fas fa-check has-text-success mr-3"></i>You are already enrolled in this course.</b-message>
                            </router-link>
                        </div>
                        <div class="column has-text-right is-narrow">
                            <b-button type="is-primary" size="" expanded @click="$emit('enroll', course)" class="mb-2" :disabled="course.enrolled || course.processing"><span v-if="!course.processing"><i class="fas fa-pencil mr-2"></i>Enroll</span><span v-else><i class="fas fa-spinner fa-spin mr-2"></i>Enrolling</span></b-button>
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <div class="details">

        </div>

    </div>
</template>

<script>
    export default {
        name: "CatalogCourse",
        props: ['course', 'details'],
        data: function() {
            return {
            };
        },
    };
</script>

<style lang="scss" scoped>
    .course {
        background-color: white;
        border-radius: 4px;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.4);

        .information {
            padding: 1.5rem 1.5rem 1.5rem;
        }

        .meta {
            font-weight: normal;
            font-size: 0.8rem;
            color: #666d7a;
        }
    }
</style>
